import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useSelected } from '../company/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useViewFile = () => {
  const { selectedCompanyId: companyId } = useSelected();
  const { mutate: viewFile } = useAppMutation([QueryKey.FILE_VIEW, companyId], {
    mutationFn: ({ fileId }: { fileId: string }) =>
      ApiService.previewFile({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'vault', 'files', fileId, 'view'],
      }),
  });

  return { viewFile };
};
